module.exports = __webpack_public_path__ + "img/tag4.c97e9ba8.png";